import { SagaIterator } from "redux-saga";
import { approveChargeSettlementApi, createChargeSettlementApi, fetchChargeSettlementAuditActionsApi, fetchChargeSettlementByExternalIdApi, fetchChargeSettlementsApi, rejectChargeSettlementApi } from "./api";
import { all, fork, put, takeEvery, call } from "redux-saga/effects";
import { ApproveRejectChargeSettlementRequest, ChargeSettlementReduxTypes, CreateChargeSettlementRequest, FetchChargeSettlementByIdRequest, FetchChargeSettlementsAuditActionsReq, FetchChargeSettlementsReq } from "./types";

function* fetchChargeSettlements({ payload }: FetchChargeSettlementsReq): SagaIterator {
  try {
    const response = yield call(fetchChargeSettlementsApi, payload);
    yield put({
      type: ChargeSettlementReduxTypes.FETCH_CHARGE_SETTLEMENTS_SUCCESS,
      payload: { data: response.data.data }
    });
  } catch (error: any) {
    yield put({
      type: ChargeSettlementReduxTypes.FETCH_CHARGE_SETTLEMENTS_ERROR,
      payload: { error: error }
    });
  }
}

function* fetchChargeSettlementByExternalId({ payload }: FetchChargeSettlementByIdRequest): SagaIterator {
  try {
    const response = yield call(fetchChargeSettlementByExternalIdApi, payload);
    yield put({
      type: ChargeSettlementReduxTypes.FETCH_CHARGE_SETTLEMENT_BY_EXTERNAL_ID_SUCCESS,
      payload: { data: response.data.data }
    });
  } catch (error: any) {
    yield put({
      type: ChargeSettlementReduxTypes.FETCH_CHARGE_SETTLEMENT_BY_EXTERNAL_ID_ERROR,
      payload: { error: error }
    });
  }
}

function* fetchChargeSettlementAuditActions({payload,type}:FetchChargeSettlementsAuditActionsReq):SagaIterator{
  try {
    const response = yield call(fetchChargeSettlementAuditActionsApi, payload);
    yield put({
      type: ChargeSettlementReduxTypes.FETCH_CHARGE_SETTLEMENT_AUDIT_ACTIONS_SUCCESS,
      payload: { data: response.data.data }
    });
  } catch (error: any) {
    yield put({
      type: ChargeSettlementReduxTypes.FETCH_CHARGE_SETTLEMENT_AUDIT_ACTIONS_ERROR,
      payload: { error: error }
    });
  }
}

function* createChargeSettlement({ payload }: CreateChargeSettlementRequest): SagaIterator {
    try {
        const response = yield call(createChargeSettlementApi, payload);
        yield put({
            type: ChargeSettlementReduxTypes.CREATE_CHARGE_SETTLEMENT_SUCCESS,
            payload: { data: response.data.data }
        })
    } catch (error: any) {
        yield put({
            type: ChargeSettlementReduxTypes.CREATE_CHARGE_SETTLEMENT_ERROR,
            payload: { error: error }
        })
    }
}

function* approveChargeSettlement({payload} : ApproveRejectChargeSettlementRequest) : SagaIterator {
    try {
        const response = yield call (approveChargeSettlementApi,payload);
        yield put ({
            type: ChargeSettlementReduxTypes.CHARGE_SETTLEMENT_APPROVE_SUCCESS,
            payload : {data : response.data.data}
        })
    } catch (error:any) {
     yield put({
        type : ChargeSettlementReduxTypes.CHARGE_SETTLEMENT_APPROVE_ERROR,
        payload : {error : error}
     })   
    }
}

function* rejectChargeSettlement({payload} : ApproveRejectChargeSettlementRequest) : SagaIterator {
    try {
        const response = yield call (rejectChargeSettlementApi,payload);
        yield put ({
            type: ChargeSettlementReduxTypes.CHARGE_SETTLEMENT_REJECT_SUCCESS,
            payload : {data : response.data.data}
        })
    } catch (error:any) {
     yield put({
        type : ChargeSettlementReduxTypes.CHARGE_SETTLEMENT_REJECT_ERROR,
        payload : {error : error}
     })   
    }
}

export function* watchChargeSettlements() {
  yield takeEvery(ChargeSettlementReduxTypes.FETCH_CHARGE_SETTLEMENTS_REQUEST, fetchChargeSettlements);
}

export function* watchChargeSettlement() {
  yield takeEvery(ChargeSettlementReduxTypes.FETCH_CHARGE_SETTLEMENT_BY_EXTERNAL_ID_REQUEST, fetchChargeSettlementByExternalId);
}

export function* watchChargeSettlementAuditActions() {
  yield takeEvery(ChargeSettlementReduxTypes.FETCH_CHARGE_SETTLEMENT_AUDIT_ACTIONS_REQUEST, fetchChargeSettlementAuditActions);
}

export function* watchCreateChargeSettlement(){
    yield takeEvery(ChargeSettlementReduxTypes.CREATE_CHARGE_SETTLEMENT_REQUEST,createChargeSettlement)
}

export function* watchApproveChargeSettlement() {
    yield takeEvery(ChargeSettlementReduxTypes.CHARGE_SETTLEMENT_APPROVE_REQUEST,approveChargeSettlement)
}

export function* watchRejectChargeSettlement() {
    yield takeEvery(ChargeSettlementReduxTypes.CHARGE_SETTLEMENT_REJECT_REQUEST,rejectChargeSettlement)
}

function* ChargeSettlementSaga() {
  yield all([fork(watchChargeSettlements), fork(watchChargeSettlement), fork(watchChargeSettlementAuditActions), fork(watchCreateChargeSettlement), fork(watchApproveChargeSettlement), fork(watchRejectChargeSettlement)]);
}

export default ChargeSettlementSaga;
